import React, { FunctionComponent, useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';

import { ReactComponent as CreateTicketsIcon } from '../../assets/images/createTicket.icon.svg';
import { CHAT, TICKET_CREATE } from '../../router/routes';

import Button from '../../components/Button/Button';
import CreateChatDialog from '../Chats/dialogs/CreateChatDialog';
import CreateChatArea from './components/CreateChatArea';

import useStyles from './styles';
import ChatWithSupport from 'pages/Chats/dialogs/ChatWithSupport';
import { useSelector } from 'react-redux';
import { PortalConfigSelector } from 'store/config/selectors';
import { tt } from '@i18n/tt';
import { useAppSelector } from '../../store/hooks';
import { UIModeSelector } from '../../store/uiMode';
import { getStorageShowNewUIModal } from '../../constants/storage';
import NewUIDesignModal from '../../components/NewUIDesignModal';

const Home: FunctionComponent = () => {
  const [openCreateChatDialog, setOpenCreateChatDialog] = useState<boolean>(false);
  const { useHelpdeskAi } = useSelector(PortalConfigSelector);

  const navigate = useNavigate();
  const classes = useStyles();

  const [showModal, setShowModal] = useState(false);
  const isNewUI = useAppSelector(UIModeSelector);

  useEffect(() => {
    if (!isNewUI) {
      const shouldShowModal = getStorageShowNewUIModal();
      setShowModal(shouldShowModal);
    }
  }, [isNewUI]);

  return (
    <div className={classes.homePage}>
      <div className={classes.homePageTile}>
        <div>
          <CreateTicketsIcon />
        </div>
        <div>
          <h1>{tt('pages.homeOld.ticketCard.title')}</h1>
          <p>
           {tt('pages.homeOld.ticketCard.description')}
          </p>
          <Button
            text={tt('pages.homeOld.ticketCard.button')}
            onClick={() => {
              navigate(TICKET_CREATE);
            }}
          />
        </div>
      </div>

      <CreateChatArea setOpenCreateChatDialog={setOpenCreateChatDialog} />

      {openCreateChatDialog && useHelpdeskAi && (
        <ChatWithSupport
          MSBot={false}
          open={openCreateChatDialog}
          onClose={() => {
            setOpenCreateChatDialog(false);
          }}
        />
      )}
      {openCreateChatDialog && !useHelpdeskAi && (
        <CreateChatDialog
          open={openCreateChatDialog}
          onClose={() => {
            setOpenCreateChatDialog(false);
          }}
          onSubmit={chatId => {
            navigate(CHAT.replace(':chatId', chatId.toString()));
          }}
        />
      )}
      {showModal && (
        <NewUIDesignModal
          open={showModal}
          onClose={() => {
            setShowModal(false);
          }}
        />
      )}
    </div>
  );
};
export default Home;
